import React from 'react';
import { SkeletonLoader } from '@/components/Loaders';

export const TagSkeleton: React.FC = () => {
	return <SkeletonLoader className="h-[83px] w-[79.77px]" rounded="lg" />;
};

TagSkeleton.displayName = 'TagSkeleton';

export default TagSkeleton;
